import { Component, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { DealerState } from '../../../store/dealer/dealer.reducer';
import {EmployeeState} from '../../../store/employee/employee.reducer';
import {  Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { DashboardOverlayService } from '../../services/dashboardoverlay.service';
import { Department } from '@signal/asp-data-commons';

@Component({
  selector: 'app-dashboard-overlay',
  templateUrl: './dashboard-overlay.component.html',
  styleUrls: ['./dashboard-overlay.component.scss']
})
export class DashboardOverlay implements OnInit {
    
    data:any[];
    activeemployees:number;
    department:string = Department.SERVICE;

  constructor(private dealerState:Store<DealerState>,
    public dialogRef: MatDialogRef<DashboardOverlay>,
    private employeeStore: Store<EmployeeState>,public dashboardOverlayService:DashboardOverlayService,
    private readonly router: Router) { 
        this.data=this.dashboardOverlayService.getData();
  }

  ngOnInit(): void {
    this.department = this.dashboardOverlayService.department;
      }

  redirect(path,key){
    this.dialogRef.close();
    if(key==="activetechnician"){
      this.router.navigate([`/asp/${this.department.toLowerCase()}/${path}`],{queryParams:{tab:"serviceTechnician"}});
    }
    else{
      this.router.navigate([`/asp/${this.department.toLowerCase()}/${path}`]);
    }
  }
}
